import styled from 'styled-components';

export const LoginContainerStyle = styled.div`
  display: flex;
  height: 100%;
  background-color: #607d84;
  justify-content: center;
  align-items: center;
`;
